export const menuItems = [
  {
    id: 1,
    label: "Dashboard",
    icon: "bx-home-circle",
    link: "/",
  },
  {
    id: 2,
    label: "Systems Administrators",
    isTitle: true,
  },
  // {
  //   id: 3,
  //   label: "Manage Schools",
  //   icon: "bx-building",
  //   link: "/schools",
  // },
  {
    id: 4,
    label: "Functionality",
    isTitle: true,
  },
  {
    id: 4,
    label: "Manage Students",
    icon: "bx bx-group",
    // badge: {
    //     variant: "info",
    //     text: "menuitems.dashboards.badge"
    // },
    subItems: [
      {
        id: 3,
        label: "Add Student",
        link: "/students/new",
        parentId: 4,
      },
      {
        id: 5,
        label: "View Students",
        link: "/students",
        parentId: 4,
      },
      {
        id: 5,
        label: "Students Archive",
        link: "/students/archive",
        parentId: 4,
      },
      // {
      //   id: 7,
      //   label: "Student Summery",
      //   link: "/students/summery",
      //   parentId: 4,
      // },
      {
        id: 7,
        label: "Student Promotions",
        link: "/students/promotions_class",
        parentId: 4,
      },
      // {
      //   id: 7,
      //   label: "Termly Promotions",
      //   link: "/students/promotions_term",
      //   parentId: 4,
      // },
    ],
  },
  {
    id: 100,
    label: "Manage Exams",
    icon: "bx-receipt",
    subItems: [
      // {
      //   id: 108,
      //   label: "View Gradings",
      //   link: "/grades",
      //   parentId: 100,
      // },
      {
        id: 109,
        label: "Enter Exam Marks",
        link: "/marks",
        parentId: 100,
      },
      // {
      //   id: 10,
      //   label: "View Exam Marks",
      //   link: "/marks/viewmarks",
      //   parentId: 7,
      // },
      // {
      //   id: 10,
      //   label: "Division Analysis",
      //   link: "/marks/divisionanalysis",
      //   parentId: 7,
      // },
      // {
      //   id: 10,
      //   label: "Subject Analysis",
      //   link: "/marks/subjectanalysis",
      //   parentId: 7,
      // },
      {
        id: 110,
        label: "View Pass Mark",
        link: "/pass-mark",
        parentId: 100,
      },
      {
        id: 16,
        label: "Report Cards",
        link: "/reports/filter",
        parentId: 11,
      },
    ],
  },
  // {
  //   id: 11,
  //   label: "Manage Tests",
  //   icon: "bx-file",
  //   subItems: [
  //     {
  //       id: 12,
  //       label: "View Test Sets",
  //       link: "/coursework/sets",
  //       parentId: 11,
  //     },
  //     {
  //       id: 13,
  //       label: "View Considered Tests",
  //       link: "/coursework/considered",
  //       parentId: 11,
  //     },
  //     {
  //       id: 14,
  //       label: "Monthly Assessment",
  //       link: "/coursework/monthlyassessment",
  //       parentId: 11,
  //     },
  //     {
  //       id: 15,
  //       label: "View Test Contribution",
  //       link: "/coursework/marked",
  //       parentId: 11,
  //     },
  //     {
  //       id: 16,
  //       label: "Report Cards",
  //       link: "/reports/filter",
  //       parentId: 11,
  //     },
  //     {
  //       id: 17,
  //       label: "Report Criterias",
  //       link: "/reports/progressive",
  //       parentId: 11,
  //     },
  //     {
  //       id: 18,
  //       label: "Progrssive Report Cards",
  //       link: "/reports/progrssive/marks",
  //       parentId: 11,
  //     },
  //     {
  //       id: 19,
  //       label: "View Report Comments",
  //       link: "/reports/comments",
  //       parentId: 11,
  //     },
  //   ],
  // },
  {
    id: 16,
    label: "Manage Users",
    icon: "bx-user-circle",
    subItems: [
      {
        id: 17,
        label: "View Users",
        link: "/users/users",
        parentId: 16,
      },
      {
        id: 18,
        label: "View Roles",
        link: "/users/roles",
        parentId: 16,
      },
      // {
      //     id: 19,
      //     label: "Permissions",
      //     link: "/users/users",
      //     parentId: 16
      // }
    ],
  },
  {
    id: 20,
    label: "Manage Fees",
    icon: "bx-money",
    subItems: [
      {
        id: 18,
        label: "Pay Fees",
        link: "/fees/pay",
        parentId: 20,
      },
      {
        id: 19,
        label: "View Fees Items",
        link: "/fees/items",
        parentId: 20,
      },
      {
        id: 22,
        label: "View Fees Settings",
        link: "/fees/setting",
        parentId: 20,
      },
      {
        id: 22,
        label: "View Fees Structure",
        link: "/fees/structure",
        parentId: 20,
      },
      {
        id: 23,
        label: "View Fees Payments",
        link: "/fees/payments",
        parentId: 20,
      },
      {
        id: 23,
        label: "View Previous Balance",
        link: "/fees/previous/debts",
        parentId: 200,
      },
      {
        id: 24,
        label: "View Fees Exemption",
        link: "/fees/exemptions",
        parentId: 20,
      },
      // {
      //   id: 25,
      //   label: "View Bursary Categories",
      //   link: "/bursary/categories",
      //   parentId: 20,
      // },
      // {
      //   id: 26,
      //   label: "View Bursary",
      //   link: "/bursaries/view",
      //   parentId: 20,
      // },
      {
        id: 17,
        label: "View Fees Addition",
        link: "/fees/additions",
        parentId: 20,
      },
      {
        id: 22,
        label: "View Fees Receipt",
        link: "/fees/receipts",
        parentId: 20,
      },
    ],
  },

  {
    id: 20,
    label: "Manage Accounting",
    icon: "bx-store",
    subItems: [
      {
        id: 21,
        label: "View Financial Year",
        link: "/view/fyears",
        parentId: 20,
      },
      {
        id: 22,
        label: "View Revenue Categories",
        link: "/revenue/categories",
        parentId: 20,
      },
      {
        id: 23,
        label: "View Expense Categories",
        link: "/expenses/categories",
        parentId: 20,
      },
      {
        id: 24,
        label: "View Revenue Projections",
        link: "/revenue/projection",
        parentId: 20,
      },
      {
        id: 25,
        label: "View Expense Projections",
        link: "/expense/projection",
        parentId: 20,
      },
      {
        id: 26,
        label: "View Budget",
        link: "/budget/view",
        parentId: 20,
      },
      {
        id: 27,
        label: "View Revenue",
        link: "/revenue/view",
        parentId: 20,
      },
      {
        id: 28,
        label: "Chart of Accounts",
        link: "/accounting/chart",
        parentId: 20,
      },
      {
        id: 29,
        label: "Accounts Settings",
        link: "/accounting/settings",
        parentId: 20,
      },
      {
        id: 30,
        label: "Journal Entries",
        link: "/accounting/journal_entry",
        parentId: 21,
      },
      {
        id: 31,
        label: "Balance Sheet",
        link: "/accounting/balancesheet",
        parentId: 21,
      },
      {
        id: 32,
        label: "Income Statement",
        link: "/accounting/incomestatement",
        parentId: 21,
      },
      // {
      //   id: 33,
      //   label: "Cash Flow",
      //   link: "/accounting/cashflow",
      //   parentId: 21,
      // },
    ],
  },
  {
    id: 28,
    label: "Manage Expense",
    icon: "bx-memory-card",
    subItems: [
      {
        id: 29,
        label: "Add Expense",
        link: "/expenses/new",
        parentId: 28,
      },
      {
        id: 30,
        label: "View Expenses",
        link: "/expenses/view",
        parentId: 28,
      },
      {
        id: 31,
        label: "View Creditors",
        link: "/creditors",
        parentId: 28,
      },
      {
        id: 32,
        label: "View Supplier",
        link: "/suppliers",
        parentId: 28,
      },
    ],
  },
  {
    id: 29,
    label: "Manage Petty Cash",
    icon: "bx-notepad",
    subItems: [
      {
        id: 29,
        label: "Petty Cash",
        link: "/pettycash",
        parentId: 29,
      },
      {
        id: 30,
        label: "Approve Petty Cash",
        link: "/pettycash/approve",
        parentId: 29,
      },
      {
        id: 31,
        label: "Payments",
        link: "/pettycash/payments",
        parentId: 29,
      },
    ],
  },
  {
    id: 30,
    label: "Manage Bulk SMS",
    icon: "bx-chat",
    subItems: [
      // {
      //   id: 31,
      //   label: "SMS Dashboard",
      //   link: "/bulk-sms",
      //   parentId: 30,
      // },
      {
        id: 32,
        label: "Send Fees SMS",
        link: "/bulk-sms/fees-sms",
        parentId: 30,
      },
      {
        id: 33,
        label: "Send Marks SMS",
        link: "/bulk-sms/marks-sms",
        parentId: 30,
      },
      {
        id: 34,
        label: "Send Custom SMS",
        link: "/bulk-sms/custom-sms",
        parentId: 30,
      },
      {
        id: 35,
        label: "Setting SMS",
        link: "/bulk-sms/settings",
        parentId: 30,
      },
    ],
  },
  // {
  //   id: 36,
  //   label: "Manage Transport",
  //   icon: "bx-car",
  //   subItems: [
  //     {
  //       id: 37,
  //       label: "School Vehicles",
  //       link: "/transport/vehicles",
  //       parentId: 36,
  //     },
  //     {
  //       id: 38,
  //       label: "Drivers",
  //       link: "/transport/drivers",
  //       parentId: 36,
  //     },
  //     {
  //       id: 39,
  //       label: "Distance Costs",
  //       link: "/transport/distances",
  //       parentId: 36,
  //     },
  //     {
  //       id: 40,
  //       label: "Student Locations",
  //       link: "/student/distances",
  //       parentId: 36,
  //     },
  //     {
  //       id: 41,
  //       label: "Vehicle Requisitions",
  //       link: "/transport/requisitions",
  //       parentId: 36,
  //     },
  //   ],
  // },
  {
    id: 42,
    label: "Manage Inventory",
    icon: "bx-chart",
    subItems: [
      {
        id: 43,
        label: "Store Items",
        link: "/store/items",
        parentId: 42,
      },
      {
        id: 44,
        label: "Stock Levels",
        link: "/store/levels",
        parentId: 42,
      },
      {
        id: 45,
        label: "New Stock",
        link: "/store/add",
        parentId: 42,
      },
      {
        id: 46,
        label: "Give Out",
        link: "/store/issue",
        parentId: 42,
      },
      {
        id: 47,
        label: "Store Logs",
        link: "/store/logs",
        parentId: 42,
      },
      {
        id: 48,
        label: "Stock Movement Report",
        link: "/store/report",
        parentId: 42,
      },
    ],
  },
  // {
  //   id: 49,
  //   label: "Manage Requirements",
  //   icon: "bx-layer",
  //   subItems: [
  //     {
  //       id: 50,
  //       label: "Setup Requirements",
  //       link: "/requirements/settings",
  //       parentId: 42,
  //     },
  //     {
  //       id: 51,
  //       label: "View Requirements",
  //       link: "/requirements",
  //       parentId: 42,
  //     },
  //     {
  //       id: 52,
  //       label: "Circular Generation",
  //       link: "/requirements/circular",
  //       parentId: 42,
  //     },
  //   ],
  // },
];
